import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { LoadingOverlay } from '@/components/Element/Loading';

// import { Notifications } from '@/components/Notifications/Notifications';

const errorFallback = ({error, resetErrorBoundary}:any) => {
  return (
    <div className="metaportal_fn_404">
      <div className="container small">
        <div className="message_holder">
          <span className="icon">
            <img src="svg/browser.svg" alt="" className="fn__svg" />
          </span>
          <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
          <button className="metaportal_fn_button" onClick={() => window.location.assign(window.location.href )}>
            Refresh
          </button>
        </div>
      </div>
    </div>


  );
};

const errorHandler = (error: Error, info: {componentStack: string}) => {
  console.log(info.componentStack)
  // Do something with the error
  // E.g. log to an error logging client here
}


type appProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: appProviderProps) => {
  return (
    <React.Suspense
      fallback={ <LoadingOverlay loading={true} />}
    >
      <ErrorBoundary FallbackComponent={errorFallback} onError={errorHandler}>
        <HelmetProvider>
          <BrowserRouter>
            {children}
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
